module.exports = __webpack_public_path__ + "media/images/flags/4x3/civ-6fb775f07d4af02c4ddbcd2de7e60d94.svg";